import { useContext, useMemo } from 'react'

import { BoxProps } from '@mantine/core'

import { GroupByStatus } from './groupByStatus'
import useStyles from './index.styles'
import SectionWrapper from '../../sectionWrapper'
import { ScheduleEventContext, ScheduleEventStatus } from '../context'

type EventListProps = BoxProps

export const EventList = ({
  className,
  classNames,
  styles,
}: EventListProps) => {
  const { listEvent = [], wrapperProps } = useContext(ScheduleEventContext)
  const { classes, cx } = useStyles(undefined, {
    name: 'ScheduleEvent__EventList',
    styles,
    classNames,
  })
  const filterList = useMemo(() => {
    return listEvent.filter((i) => i.state === ScheduleEventStatus.NOT_YET)
  }, [listEvent])
  return filterList.length > 0 ? (
    <SectionWrapper
      className={cx(className, classes.root)}
      {...wrapperProps}
      title=""
      description=""
    >
      <GroupByStatus listEvent={filterList} />
    </SectionWrapper>
  ) : null
}
